import { getEnvironmentAppUrls } from '@dvag/dfs-constant-config';
import { getToken } from '@dvag/dfs-orchestrator-client';
import type { FC } from 'react';
import { createElement, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { getDevEnv } from 'service/envConfig';

// Prefix indicating that an activeForm path refers to a specific section
const ACTIVE_FORM_SECTION_PREFIX = '.';

export const KundenstammdatenWebComponent: FC = () => {
  const { personId, activeForm } = useParams<{ personId: string; activeForm: string }>();

  useEffect(() => {
    const env = getDevEnv();
    const appUrls = getEnvironmentAppUrls(env);
    const scriptSrc = appUrls.kundenstammdatenDVAG;
    type KundenstammdatenElement = HTMLElement & {
      authenticationToken?: () => Promise<string | void>;
      kundennummer?: string;
      features?: string;
      navigateto?: string;
    };

    const setLuigiAuthenticationProvider = (): void => {
      const element = document.querySelector('dvag-kundenstammdaten') as KundenstammdatenElement;
      if (!element) {
        return;
      }
      element.authenticationToken = (): Promise<string | void> => Promise.resolve(getToken());
      if (personId) {
        element.kundennummer = personId;
      }
      if (activeForm) {
        element.navigateto = activeForm;
      }
    };

    if (!document.querySelector(`script[src="${scriptSrc}"]`)) {
      const script = document.createElement('script');
      script.src = scriptSrc;

      script.type = 'module';
      script.addEventListener('load', setLuigiAuthenticationProvider);
      document.head.appendChild(script);
    }
    setLuigiAuthenticationProvider();
  }, [personId, activeForm]);

  const buttonToShow = activeForm?.startsWith(ACTIVE_FORM_SECTION_PREFIX)
    ? 'showNextButton'
    : 'showBackButton';

  return createElement('dvag-kundenstammdaten', {
    features: `${buttonToShow},showNamensaenderung,showAdressaenderung,showBankverbindungsaenderung`,
    navigateto: activeForm,
  });
};
